/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Listings_Filter_AllInputs */

const en_seller_listings_filter_all = /** @type {(inputs: Seller_Listings_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const es_seller_listings_filter_all = /** @type {(inputs: Seller_Listings_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos`)
};

const fr_seller_listings_filter_all = /** @type {(inputs: Seller_Listings_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toutes`)
};

const de_seller_listings_filter_all = /** @type {(inputs: Seller_Listings_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle`)
};

const ja_seller_listings_filter_all = /** @type {(inputs: Seller_Listings_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべて`)
};

const zh_seller_listings_filter_all = /** @type {(inputs: Seller_Listings_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部`)
};

const ar_seller_listings_filter_all = /** @type {(inputs: Seller_Listings_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الكل`)
};

const id_seller_listings_filter_all = /** @type {(inputs: Seller_Listings_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua`)
};

const it_seller_listings_filter_all = /** @type {(inputs: Seller_Listings_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutti`)
};

const ru_seller_listings_filter_all = /** @type {(inputs: Seller_Listings_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все`)
};

const pt_seller_listings_filter_all = /** @type {(inputs: Seller_Listings_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos`)
};

const ko_seller_listings_filter_all = /** @type {(inputs: Seller_Listings_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전체`)
};

/**
* | output |
* | --- |
* | "All" |
*
* @param {Seller_Listings_Filter_AllInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_listings_filter_all = /** @type {((inputs?: Seller_Listings_Filter_AllInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Listings_Filter_AllInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_listings_filter_all(inputs)
	if (locale === "es") return es_seller_listings_filter_all(inputs)
	if (locale === "fr") return fr_seller_listings_filter_all(inputs)
	if (locale === "de") return de_seller_listings_filter_all(inputs)
	if (locale === "ja") return ja_seller_listings_filter_all(inputs)
	if (locale === "zh") return zh_seller_listings_filter_all(inputs)
	if (locale === "ar") return ar_seller_listings_filter_all(inputs)
	if (locale === "id") return id_seller_listings_filter_all(inputs)
	if (locale === "it") return it_seller_listings_filter_all(inputs)
	if (locale === "ru") return ru_seller_listings_filter_all(inputs)
	if (locale === "pt") return pt_seller_listings_filter_all(inputs)
	return ko_seller_listings_filter_all(inputs)
});